import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-items: center;
    width: ${({ width }) => width};
    background-color: ${COLORS.AGREE_CHECKBOX.BACKGROUND};
    padding: 15px 32px 12px 32px;
    margin: 20px 0px 20px 0px;
  `,
  message: css`
    color: ${props =>
      props.error ? COLORS.MESSAGE.ERROR.TEXT : COLORS.TEXT.BLACK};
    margin-bottom: 6px;
  `
};

export default styles;
